import React, {Fragment} from "react";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import agent_b from "./assets/images/agent_b.png";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown,Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import phone from "./assets/images/phone.svg";
import message_1 from "./assets/images/message_1.svg";
import Loading from "../../Common/Loading";
import { Minimize } from "../Common/Minimize";
import cx from "classnames";
import { useWebCallContext } from '../../Common/WebCallContext';
import { checkIsAgencyView, getSessionValue, isMobile } from "../../Common/Appcommon";

const AgentMainHeader = (props) => {
    const {isCallReady} = useWebCallContext();
    const isAgencyView = checkIsAgencyView();
    let {rowData, fieldNames,isLoading, onHideSubMenu, isMinimized ,showAgentLoading,allowDuplicateAgents,allowDeleteAgents,allowPublishAgents,onPublish,voiceList, getBackListView} = props;
    let option = [
        {
            label : "Delete",
            value : "delete"
        },
        {
            label : "Duplicate",
            value : "duplicate"
        },
    ];
    let dropdownoption = [
        {
            label : "Webcall",
            value : "webcall",
            icon : phone
        },
        {
            label : "Chat",
            value : "chat",
            icon : message_1
        },
    ];

    let agentOption = [
        {
            label : "Clone",
            value : "clone",
            icon : <i class="fi fi-rr-duplicate"></i>
        },
        {
            label : "Delete",
            value : "delete",
            icon : <i class="fi fi-rr-trash"></i>
        },
        {
            label : "View Log",
            value : "Post_Call_Event",
            icon : <i class="fi fi-rr-document"></i>
        },
    ];

    let icon = agent_b;
    // let Gender = rowData['Gender'] !== undefined ? rowData['Gender'] : "";
    // if (Gender.toLowerCase() === "female") {
    //     icon = women_user;
    // }

    const showAgentOptions = () =>{
        return(
            <>
                <UncontrolledDropdown>
                    <DropdownToggle className="agent-test-btn mb-2 pl-2">
                        <button className='dot-icon mt-2' disabled = {isLoading}>
                            <i class="fi fi-bs-menu-dots-vertical dot-div"></i>
                        </button>
                    </DropdownToggle>
                    <DropdownMenu className="plans-dropdown agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                        {
                            agentOption && 
                            agentOption.map((option, index) => {
                                let label = option.label;
                                let value = option.value;
                                let menuicon = option.icon;
                                if(!isAgencyView){
                                    if (
                                        (value === "clone" && !allowDuplicateAgents) || 
                                        (value === "delete" && !allowDeleteAgents)
                                    ) {
                                        return;
                                    }
                                }

                                return (
                                    <DropdownItem 
                                        className="dropdown-list" 
                                        onClick={e => props.handleAgentOptionChange(option, value)}
                                    >
                                        {menuicon}
                                        <span>
                                            {label}
                                        </span>
                                    </DropdownItem>
                                )
                            })
                        }
                    </DropdownMenu>
                </UncontrolledDropdown>            
            </>
        )
    }

    const onSave = () =>{
        onPublish();  // <-- call the function here!    
    }

    let voiceId = rowData["voice_id"];
    let voice = voiceList.flat().find(voice => voice.Voice_Id === voiceId);
    // setVoiceicon(voice["Agent_Icon"]);
    let isMobileView = isMobile();

    return(
        <Fragment>
            {
                isMobileView ? (
                    <div className="app-header-title w-100 px-3">
                        <div className='agent-main-container d-flex'>
                            {
                                Object.keys(rowData).length > 0 && 
                                <div className='container-heading'>
                                    {/* <img src={icon} className="agent-img"/> */}
                                    <span className="agent-icon">
                                    {
                                        (
                                            voice?.["Icon"] ? (
                                                <img src={voice?.["Icon"]} className=""></img>
                                            ) : (
                                                <i className="fi fi-ss-user-headset"></i>
                                            )
                                        )
                                    }
                                    </span> 
                                    <div className="agent-header-div">
                                        {rowData[fieldNames['Agent_Name']] !== undefined ? rowData[fieldNames['Agent_Name']] : "AI Agent"}
                                    </div>
                                </div>
                            }
                        </div>
                        <Loading 
                            showLoader={false}
                            mainContent={
                                <div className="d-flex align-items-center gap-1 mt-2 ms-auto">
                                    {false && <button className={cx("btn btn-list theme-bg-g d-flex", {"disabled": isLoading},{"disabled": isCallReady})}  onClick={e => props.handleDropDownChange("webcall")}><i class="fi fi-rr-phone-call pr-1"></i>Talk with AI Agent</button>}
                                    {
                                        (isAgencyView || allowPublishAgents) && 
                                        <Button 
                                            onClick={onSave} 
                                            className="btn btn-list theme-bg-g" 
                                            disabled = {isLoading}>
                                                Publish
                                        </Button>}
                                    {showAgentOptions()}
                                </div>
                            }
                        />
                    </div>
                ) : (
                    <div className="app-header-title">
                        <Minimize 
                            onHideSubMenu={onHideSubMenu} 
                            isMinimized={isMinimized}
                        />
                        <div className='agent-main-container'>
                            {
                                Object.keys(rowData).length > 0 && 
                                <div className='container-heading'>
                                    {/* <img src={icon} className="agent-img"/> */}
                                    <span className="agent-icon">
                                    {
                                        (
                                            voice?.["Icon"] ? (
                                                <img src={voice?.["Icon"]} className=""></img>
                                            ) : (
                                                <i className="fi fi-ss-user-headset"></i>
                                            )
                                        )
                                    }
                                    </span> 
                                    <div className="agent-header-div">
                                        {rowData[fieldNames['Agent_Name']] !== undefined ? rowData[fieldNames['Agent_Name']] : "AI Agent"}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            }
            {
                !isMobileView && (
                    <div className="header-main-body agent-header">
                        <Loading 
                            showLoader={false}
                            mainContent={
                                <div className="d-flex align-items-center gap-1 mt-2">
                                    {false && <button className={cx("btn btn-list theme-bg-g d-flex", {"disabled": isLoading},{"disabled": isCallReady})}  onClick={e => props.handleDropDownChange("webcall")}><i class="fi fi-rr-phone-call pr-1"></i>Talk with AI Agent</button>}
                                    {
                                        (isAgencyView || allowPublishAgents) && 
                                        <Button 
                                            onClick={onSave} 
                                            className="btn btn-list theme-bg-g" 
                                            disabled = {isLoading}>
                                                Publish
                                        </Button>}
                                    {showAgentOptions()}
                                </div>
                            }
                        />
                    
                        {
                            false &&
                            <UncontrolledDropdown>
                                <DropdownToggle className="agent-test-btn">
                                    Test Again <FontAwesomeIcon icon={faAngleDown} color='#e5e7eb' className='down-arrow theme-c-g me-4'/>
                                </DropdownToggle>
                                <DropdownMenu className="agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                                    {
                                        dropdownoption && 
                                        dropdownoption.map((option, index) => {
                                            let label = option.label;
                                            let value = option.value;
                                            let menuicon = option.icon;
                                            return (
                                                <DropdownItem 
                                                    className="dropdown-list" 
                                                    onClick={e => props.handleDropDownChange(option, value)}
                                                >
                                                    <img src={menuicon} />
                                                    <span>
                                                        {label}
                                                    </span>
                                                </DropdownItem>
                                            )
                                        })
                                    }
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        }
                    </div>
                )
            }
        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentMainHeader);